import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '@/utils/cn';
import styles from './RadioGroup.module.scss';
import type { RadioGroupProps } from './RadioGroup.types';

export const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  RadioGroupProps
>(({ className, options, label, error, required, ...props }, ref) => {
  return (
    <div className={cn(styles.radioGroup, className)}>
      {label && (
        <label className={styles.radioGroup__label}>
          {label}
          {required && <span className={styles.radioGroup__required}>*</span>}
        </label>
      )}

      <RadioGroupPrimitive.Root
        className={cn(styles.radioGroup__root, error && styles['radioGroup__root--error'])}
        ref={ref}
        {...props}
      >
        {options.map((option) => (
          <div key={option.value} className={styles.radioGroup__item}>
            <RadioGroupPrimitive.Item
              value={option.value}
              disabled={option.disabled}
              className={styles.radioGroup__radio}
              id={`radio-${option.value}`}
              data-no-press-scale=""
            >
              <RadioGroupPrimitive.Indicator className={styles.radioGroup__indicator} />
            </RadioGroupPrimitive.Item>

            <label htmlFor={`radio-${option.value}`} className={styles.radioGroup__itemLabel}>
              <span className={styles.radioGroup__itemText}>{option.label}</span>
              {option.description && (
                <span className={styles.radioGroup__itemDescription}>{option.description}</span>
              )}
            </label>
          </div>
        ))}
      </RadioGroupPrimitive.Root>

      {error && <span className={styles.radioGroup__error}>{error}</span>}
    </div>
  );
});

RadioGroup.displayName = 'RadioGroup';
